import { MarkdownRender } from '@/components/markdown/markdownRender';
import UserAvatar from '@/components/ui/userAvatar';
import { AuthContext } from '@/store';
import { useNodeProps } from '@/node-editor/hooks';
import { INode, INodeProps } from '@/types/node';
import { Box, Button, Icon, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useContext, useState } from 'react';
import { IContent } from './contract';
import { useTheme, Theme } from '@mui/material/styles';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

interface IContainerStyleProps {
  override: Record<string, any>;
}

const useContainerStyles = (
  theme: Theme,
  { override }: IContainerStyleProps
) => ({
  root: {
    width: '100% !important',
    padding: `${theme.spacing(1)} !important`,
    ...override.root,
  },
});

export const Render = ({
  node: {
    id,
    override,
    content: { description, received, topicSlug },
  },
  conferenceId,
}: IProps) => {
  const theme = useTheme();
  const classes = useContainerStyles(theme, {
    override,
  });
  const { authState } = useContext(AuthContext);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);
  const [title, setTitle] = useState<string>('');
  const post = () => {
    setSending(true);
    axios
      .post(`/api/visitor/conferences/${conferenceId}/discussions`, {
        topicSlug,
        title: title,
      })
      .then(() => {
        setTitle('');
        setError('');
        setSuccess(true);
      })
      .catch((e) => {
        setError(e.response.data.message);
      })
      .then(() => {
        setSending(false);
      });
  };
  return (
    <Box sx={classes.root} {...useNodeProps(id)}>
      {authState.user ? (
        <>
          <MarkdownRender text={description} />
          {!topicSlug && (
            <Typography color="error">Please select topic</Typography>
          )}
          <TextField
            name="title"
            value={title}
            variant="outlined"
            size="small"
            fullWidth
            onChange={(e) => setTitle(e.target.value)}
          />
          <Box display="flex">
            <Box flexGrow={1} p={1}>
              {success && received}
              {error && <Typography color="error">{error}</Typography>}
            </Box>
            <Box pt={1}>
              <UserAvatar user={authState.user} size="small" />
            </Box>
            <Button
              disabled={sending || title === '' || !topicSlug}
              endIcon={<Icon>send</Icon>}
              color="primary"
              onClick={post}
            >
              post
            </Button>
          </Box>
        </>
      ) : (
        'Need to be logged in'
      )}
    </Box>
  );
};
